import { connectorByIdQuery } from 'src/services/DOM/queries/connectorById/__generated__/connectorByIdQuery.graphql';
import { OverviewType } from '../../../../OverviewCard';
import { printLocalDatetimeWithTimezone } from 'src/products/connector/utils/printLocalDatetimeWithTimezone';
import { BuildModelsOverviewReturn } from './model';
import { ConnectorStages } from 'src/products/connector/constants';

const chooseStatusObjectByStage = (
  model: connectorByIdQuery['response']['connector']['models'][0],
  stage?: ConnectorStages
) => {
  let statusObject = model.statusObject;

  if (stage === ConnectorStages.DEV) {
    statusObject = model.devStatusObject;
  }

  if (stage === ConnectorStages.QC) {
    statusObject = model.qcStatusObject;
  }

  return statusObject;
};

export const buildModelsOverview = (
  models: connectorByIdQuery['response']['connector']['models'],
  stage?: ConnectorStages
): BuildModelsOverviewReturn[] =>
  models.map((model) => ({
    type: OverviewType.MODEL,
    name: model.name,
    displayName: model.displayName,
    revision: Math.max(
      ...model.publishedRevisions.map((r) => r.revisionNumber),
      0
    ).toString(),
    preconfiguredModelRef: model.preconfiguredModelRef,
    provider: model.provider,
    created: printLocalDatetimeWithTimezone(
      'MMM D YYYY h:mm A',
      model.createdAt
    ),
    creator: 'Cherre',
    statusObject: chooseStatusObjectByStage(model, stage),
    egressedTables: model.egressedTables,
  }));
